<template>
	<Modulo v-for="modulo in modulos" :key="modulo.idChecklistModulo" :modulo="modulo"/>
</template>

<script>

import { defineComponent } from 'vue'
import Modulo from '@/common/Modulo.vue'
import ComponentePreviewChecklistService from '@/services/componentes/ComponentePreviewChecklistService';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';

export default defineComponent({
	name: 'PreviewChecklist',
	components: {
		Modulo
	},
	props: {
        ...PropsComponentesConstant.PROPS,
    },
	setup(props) {
		return ComponentePreviewChecklistService.setup(props)
	}
})
</script>